import Params               from "dashboard/dist/Core/Params";
import { setSection }       from "Actions/Core/CoreActions";
import { Material }         from "Utils/API";

// Types
import {
    MATERIAL, MATERIAL_LOADING, MATERIAL_CHARGING,
    MATERIAL_LIST, MATERIAL_ELEM, MATERIAL_CREATE
} from "Utils/Types";



/**
 * Fetches the Material List
 * @param {String=} type
 * @param {Number=} elemID
 * @param {Object=} params
 * @returns {(dispatch) => Void}
 */
export function fetchMaterials(type = "", elemID = 0, params = {}) {
    return async (dispatch) => {
        dispatch({ type : MATERIAL_LOADING });
        Params.unset(params);
        let data = {};

        switch (type) {
        case "COURSE":
            params.courseID = elemID;
            data = await Material.getAllForCourse(params);
            break;
        default:
            data = await Material.getAll(params);
        }
        data.sort = params;
        dispatch({ type : MATERIAL_LIST, data });
        dispatch(setSection(MATERIAL));
    };
}

/**
 * Fetches a single Material
 * @param {Number}   materialID
 * @param {Boolean=} withLoader
 * @returns {(dispatch) => Void}
 */
export function fetchMaterial(materialID, withLoader = false) {
    return async (dispatch) => {
        if (withLoader) {
            dispatch({ type : MATERIAL_CHARGING });
        }
        const data = await Material.getOne({ materialID });
        dispatch({ type : MATERIAL_ELEM, data });
    };
}

/**
 * Fetches the Material Create data
 * @param {Number} courseID
 * @returns {(dispatch: Function) => Void}
 */
export function fetchMaterialCreate(courseID) {
    return async (dispatch) => {
        const data = await Material.getCreateData({ courseID });
        dispatch({ type : MATERIAL_CREATE, data });
    };
}



/**
 * Edits/Creates a Material
 * @param {Object} data
 * @returns {() => Void}
 */
export function editMaterial(data) {
    return () => Material.edit(data);
}

/**
 * Deletes a Material
 * @param {Number} materialID
 * @returns {() => Void}
 */
export function deleteMaterial(materialID) {
    return () => Material.delete({ materialID });
}
